import { AxiosError, AxiosRequestConfig } from 'axios';
import { apiGet, apiPost } from "services/api";
import { IOrderPriceEdition, IOrderWithProductPrices } from 'types/orders';

const { REACT_APP_SUBSCRIPTION } = process.env;

const getOrderWithProductPrices = async (orderId: number | string) => {
  return apiGet<AxiosRequestConfig, IOrderWithProductPrices>(
    `${REACT_APP_SUBSCRIPTION}/order/with-products-prices/${orderId}`
  )
    .then(response => Promise.resolve(response))
    .catch((error: AxiosError) => Promise.reject(error));
};

const saveOrderPriceEdition = async (body: IOrderPriceEdition) => {
  return apiPost<AxiosRequestConfig, IOrderPriceEdition>(
    `${REACT_APP_SUBSCRIPTION}/order-edit-price/bulk-changes-with-items`,
    body
  )
    .then(response => Promise.resolve(response))
    .catch((error: AxiosError) => Promise.reject(error));
};

export { getOrderWithProductPrices, saveOrderPriceEdition };
